import styled from '@emotion/styled'
import Title from '@organisms/Title'

export const Wrapper = styled.div`
  margin-top: 10px;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const StyledTitle = styled(Title)`
  white-space: pre-line;
  margin-right: 12px;
  flex: 1 1 auto;
  min-width: 0;
`

export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  transform: translateY(0.5px);
`
